<template>
  <div class="wraper">
    <el-row class='top'>
      <span>已启用设备</span>
      <el-button @click="addDevice" size="mini" type="primary">添加设备到分组</el-button>
      <el-dialog title="添加到分组统计" :visible.sync="AddGroupVisible" center width="30%">
        <el-form :model="addform">
          <el-form-item label="设备分组名称" label-width="50%">
            <el-select v-model="addform.group" size="mini" placeholder="选择分组" style="width: 140px">
              <el-option
                v-for="(item,index)  in groupMap"
                :key="index"
                :label="item"
                :value="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearForm">取 消</el-button>
          <el-button type="primary" @click="addGroup">确 定</el-button>
        </div>
      </el-dialog>
      <div class="export_btn">
        <exporter
          :setting='setting'
          :postParams='postParams'
          :url='getListUrl'
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <deviceSearchBox
      :postParams='postParams'
      @getSearchSelect="searchTable"
      @getGroup="getGroupMap"
    ></deviceSearchBox>
    <el-row>
      <report
        :setting='setting'
        :list='list'
        @callFather='handleSun'
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'
    import deviceSearchBox from '../devices/components/deviceSearchBox'

    export default {
        name: 'device',
        components: {
            Report,
            exporter,
            deviceSearchBox
        },
        data() {
            return {
                exportName:'已启用报表',
                getListUrl: 'data/getAssetsManagementList',
                addGroupRelative: 'data/addGroupRelative',
                assets:'',
                postParams: {
                    areaCompanyId: '',
                    provinceBranchCompanyId: '',
                    productModelType: '',
                    agencyType: '',
                    channelType: '',
                    groupName:"",
                    secondChannelType: '',
                    thirdChannelType: '',
                    dealerCompanyId: '',
                    cityCode: '',
                    marketType: '',
                    provinceCode: '',
                    putPolicy: '',
                    storeId: '',
                    keyWord: '',
                },
                currentPage: 1,
                setting: {
                    btnsWidth: '200px',
                    isShowSelect: true,
                    isShowIndex: false,
                    tHeader: [{
                        dataItem: 'assetsNum',
                        dataName: '资产编号',
                        width: '200px'
                    }, {
                        dataItem: 'areaCompanyName',
                        dataName: '大区',
                        width: '120px'
                    }, {
                        dataItem: 'provinceBranchCompanyName',
                        dataName: '省区/分公司',
                        width: '160px'
                    }, {
                        dataItem: 'productModelType',
                        dataName: '冷柜系列',
                        width: '120px'
                    }, {
                        dataItem: 'channelTypeName',
                        dataName: '渠道类型',
                        width: '120px'
                    }, {
                        dataItem: 'secondChannelTypeName',
                        dataName: '二级渠道类型',
                        width: '140px'
                    }, {
                        dataItem: 'thirdChannelTypeName',
                        dataName: '三级渠道类型',
                        width: '140px'
                    }, {
                        dataItem: 'marketTypeName',
                        dataName: '市场类型',
                        width: '120px'
                    }, {
                        dataItem: 'dealerCompanyName',
                        dataName: '经销商名称',
                        width: '200px'
                    }, {
                        dataItem: 'storeName',
                        dataName: '网点名称',
                        width: '200px'
                    }, {
                        dataItem: 'agencyTypeName',
                        dataName: '客户类型',
                        width: '200px'
                    }, {
                        dataItem: 'provinceName',
                        dataName: '省份',
                        width: '100px'
                    }, {
                        dataItem: 'cityName',
                        dataName: '城市',
                        width: '100px'
                    }, {
                        dataItem: 'putPolicyName',
                        dataName: '投放政策',
                        width: '250px'
                    }],
                    isShowPlay: true,
                    isShowDelBtn: false,
                    isShowEditBtn: false,
                    isShowInfoBtn: false,
                    isshowGoodsBtn: true,
                    infoUrl: 'devicesImages',
                    status: 1
                },
                list: [],
                total: 0,
                pageSize: 10,
                addform: {
                    group: ""
                },
                groupMap: {},
                AddGroupVisible: false,
                imei: ''
            }
        },
        mounted() {
            this.postParams.channelType = this.$route.params.channelType;
            this.postParams.groupName = this.$route.params.groupName

            if (this.$route.params.date) {
              this.postParams.startDay = this.$route.params.date[0]
              this.postParams.endDay = this.$route.params.date[1]
            }
            this.assets = this.$route.params.assets
            this.getList()
        },
        methods: {
            getList() {
                let url = this.getListUrl;
                let paramsObj = this.postParams;
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.currentPage,
                    status: 1,
                    assets:this.assets
                }
                for (let k in paramsObj) {
                    if (paramsObj[k] != '')
                        params[k] = paramsObj[k];
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {

                    const data = res.data.data;
                    this.list = data.list;
                    this.total = data.total;
                    console.log(this.list)
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            search() {
                this.getList();
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun(res) {
                var str = ''
                for (var i = 0; i < res.length; i++) {
                    str += res[i].assetsNum + ','
                }
                if (str.length > 0) {
                    str = str.substr(0, str.length - 1);
                }
                this.imei = str;
            },
            searchTable() {
                this.getList();
            },
            addDevice() {
                if (this.imei.length == 0) {
                    this.$message.warning('请选择设备');
                    return;
                }
                var _this = this;
                var params = {
                    groupId: '',
                    assetsNums: _this.imei,
                    isGoOn: false
                }
                var url = _this.addGroupRelative
                this.$ajax.post(url, params)
                    .then(function (res) {
                        var data = res.data;
                        if (data && data.code === 200) {
                            _this.AddGroupVisible = true;
                        } else if (data && data.code === 500) {
                            _this.$confirm(data.msg, '提示', {
                                confirmButtonText: '继续',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                _this.AddGroupVisible = true;
                            }).catch(() => {
                                // _this.$message({
                                //   type: 'info',
                                //   message: '已取消操作'
                                // });
                            });
                        } else {
                            var errMsg = '未知错误'
                            if (res.data.msg) {
                                errMsg = res.data.msg;
                            }
                            _this.$message.error(errMsg);
                        }
                    }).catch(function (res) {
                    _this.$message.error('哎呀~网络异常了呢');
                })
            },
            clearForm() {
                this.addform = {
                    group: ''
                }
                this.AddGroupVisible = false
            },
            addGroup() {
                if (this.addform.group === '') {
                    this.$message.error('请选择分组');
                    return;
                }
                var _this = this;
                _this.AddGroupVisible = false
                var params = {
                    groupId: _this.addform.group,
                    assetsNums: _this.imei,
                    isGoOn: true
                }
                var url = _this.addGroupRelative
                this.$ajax.post(url, params)
                    .then(function (res) {
                        var data = res.data;
                        if (data && data.code === 200) {
                            _this.$message.success('操作成功！');
                        } else {
                            var errMsg = '未知错误'
                            if (res.data.msg) {
                                errMsg = res.data.msg;
                            }
                            _this.$message.error(errMsg);
                        }
                        _this.addform.group = ''
                    }).catch(function (res) {
                    _this.$message.error('哎呀~网络异常了呢');
                })
            },
            getGroupMap(res) {
                this.groupMap = res;
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/devices/devicesStart.vue